import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  // tslint:disable-next-line:component-selector
  selector: "div[pageTitle-box-topline], nx-pageTitle-box-topline",
  templateUrl: "pageTitle-box-topline.html",
})
export class PageTitleBoxToplineComponent {

  /**
   * The subLabel of the box
   */
  @Input() bcRootLvlLabel: string | undefined;

  /**
   * Path the router should be navigated to when the sublabel is cliecked
   */
  @Input() bcRootLvlPath: string | undefined;

  /**
   * The subLabel of the box
   */
  @Input() bcRootLvl1Label: string | undefined;

  /**
   * Path the router should be navigated to when the sublabel is cliecked
   */
  @Input() bcRootLvl1Path: string | undefined;

  constructor(
    private router: Router
  ) {
  }

  public goTo(path: string) {
    this.router.navigate([path]);
  }

}
